import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LS } from './localStorage.enum';
import { DataService } from '../services/data/data.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private dataService: DataService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentUser = JSON.parse(localStorage.getItem(LS.currentUser));
    if (currentUser && currentUser.token) {
      request = request.clone({
        setHeaders: {
          // 'Content-Type': 'application/json',
          Authorization: `Bearer ${currentUser.token}`,
        },
      });
    }

    return next.handle(request).pipe(
      tap(
        () => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            switch (err.status) {
              case 401:
                
                const cache = localStorage.getItem(LS.defaultLang)
                  , host = localStorage.getItem(LS.host);
                localStorage.clear();
                if (cache) this.dataService.setLocalStorage(LS.defaultLang, cache);
                if (host) this.dataService.setLocalStorage(LS.host, host);
                location.reload()
                break;
              case 403:
                
                break;
            
              default:
                break;
            }
            return
          }
        }
      )
    );
  }
}
